import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-608707a0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "opModal" }
const _hoisted_2 = { class: "text-center mb-4" }
const _hoisted_3 = {
  key: 0,
  class: "text-center"
}
const _hoisted_4 = { class: "fs-22 text-danger" }
const _hoisted_5 = {
  filter: "nome",
  sort: "nome"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { colspan: "99" }
const _hoisted_9 = { class: "text-right" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { key: 0 }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-check" }, null, -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_15 = { class: "d-flex justify-content-between" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_op_table = _resolveComponent("op-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_localized_text, {
        localizedKey: "Seleziona le offerte che saranno proposte al cliente come upsell",
        text: "Seleziona le offerte che saranno proposte al cliente come upsell"
      })
    ]),
    (_ctx.upsellCategoryNotFound)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, [
            _createVNode(_component_localized_text, {
              localizedKey: "Non è stata impostata una categoria per gli upsell!",
              text: "Non è stata impostata una categoria per gli upsell!"
            })
          ])
        ]))
      : (_openBlock(), _createBlock(_component_op_table, {
          key: 1,
          class: "table table-striped w-100",
          items: _ctx.offertas
        }, {
          default: _withCtx((opData) => [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("td", _hoisted_5, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Nome",
                    text: "Nome"
                  })
                ]),
                _hoisted_6
              ])
            ]),
            _createElementVNode("tbody", null, [
              (opData.items.length == 0)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_7, [
                    _createElementVNode("td", _hoisted_8, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Nessun elemento trovato",
                        text: "Nessun elemento trovato"
                      })
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(opData.items, (item, i) => {
                return (_openBlock(), _createElementBlock("tr", { key: i }, [
                  _createElementVNode("td", null, _toDisplayString(item.name) + " - " + _toDisplayString(item.subtitle), 1),
                  _createElementVNode("td", _hoisted_9, [
                    _createElementVNode("button", {
                      type: "button",
                      class: _normalizeClass(["btn btn-check", { 'btn-success': _ctx.hasOffer(item)}]),
                      onClick: ($event: any) => (_ctx.toggleOffer(item))
                    }, [
                      (_ctx.hasOffer(item))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_11, _hoisted_13))
                        : _createCommentVNode("", true)
                    ], 10, _hoisted_10)
                  ])
                ]))
              }), 128))
            ])
          ]),
          _: 1
        }, 8, ["items"])),
    _hoisted_14,
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-danger",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.annulla && _ctx.annulla(...args)))
      }, [
        _createVNode(_component_localized_text, {
          localizedKey: "Annulla modifiche e chiudi",
          text: "Annulla modifiche e chiudi"
        })
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-success",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.ok && _ctx.ok(...args)))
      }, [
        _createVNode(_component_localized_text, {
          localizedKey: "Ok e chiudi",
          text: "Ok e chiudi"
        })
      ])
    ])
  ]))
}